import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const API_BASE_URL = "https://api.ui.com/v1";

export const unifiSiteManager = defineConnector({
  identifier: "unifiSiteManager",
  name: "UniFi Site Manager",
  tagLine: "Cloud management for UniFi deployments",
  keywords: "ubiquiti hosts sites devices isp sd-wan",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () =>
    "https://api\\.ui\\.com/v1/(?:connector|devices|hosts|isp-metrics|sd-wan-configs|sites)(?:$|[/?].*)",
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a UniFi Site Manager API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [UniFi Site Manager](https://unifi.ui.com), create an API key under **Settings → API Keys**.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: `${API_BASE_URL}/hosts`,
      method: "GET",
      headers: { Accept: "application/json" },
    }),
  },
});
